/**
 * Global Constants
 * 
 * Centralized configuration for global constants across the application.
 * Update these values to change application-wide settings.
 */

// ============================================
// Debug and Security Configuration
// ============================================

const IS_DEBUG = process.env.REACT_APP_DEBUG_MODE === 'true' || false;

const IS_LOCALHOST = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

/**
 * Enable/disable debug mode
 * @type {boolean}
 */
export const DEBUG_MODE_ENABLED = IS_DEBUG && IS_LOCALHOST;

/**
 * Enable/disable encryption for API requests
 * @type {boolean}
 */
export const ENCRYPTION = IS_DEBUG ? false : true;

/**
 * Enable/disable authentication requirement
 * If true, works with standard authentication
 * If false, bypasses sign-in and goes directly to /dashboard
 * @type {boolean}
 */
export const REQUIRE_AUTH = IS_DEBUG ? false : true;

/**
 * Enable/disable RBAC (Role-Based Access Control)
 * @type {boolean}
 */
export const RBAC_ENABLED = IS_DEBUG ? false : true;
